// extracted by mini-css-extract-plugin
export default {"button":"StyledButton_button__KY5sy"};